import { message } from 'antd';
import i18n from '../../i18n';
import { ERROR } from '../constants/apiStatusCodeMap';
import { API_ERROR_MESSAGES } from '../translationValues';

export const clearUserData = (redirect = true) => {
  window.localStorage.setItem('CREDENTIALS_FLUSH', Date.now().toString())
  window.localStorage.removeItem('CREDENTIALS_FLUSH')
  // clear the local storage
  localStorage.removeItem('lockedprintTemplateId');
  localStorage.removeItem('lockedemailTemplateId');
  localStorage.removeItem('lockedemailElementId');
  localStorage.removeItem('lockedprintElementId');
  // redirect to the login screen
  if (redirect) {
    window.location.href = '/';
  }
};

const setupInterceptors = response => {
  // Add a response interceptor
  return response;
};

const errorResponseHandler = response => {
  if (response && response.errors && response.errors.length > 0) {
    let errorMessage = '';
      const key = ERROR[response.errors[0].code];
      if (key && API_ERROR_MESSAGES[key]) {
        errorMessage = i18n.t(`API_ERROR_MESSAGES:${API_ERROR_MESSAGES[key].key}`, API_ERROR_MESSAGES[key].value);
      } else {
        errorMessage = response.errors[0].description;
      }
    if (response.errors[0].description.includes('Invalid Token')
      || response.errors[0].code === 101
      || response.errors[0].code === 102
      || response.errors[0].code === 113
      || response.errors[0].code === 915
      || response.errors[0].code === 1004) {
      return;
    }
    if (errorMessage === null) {
      message.error("Oops! Something went wrong, cannot process request.");
    } else if (errorMessage === undefined) {
      message.error("Oops! Something went wrong");
    } else {
      message.error(errorMessage);
    }
  }
};

export default {
  setupInterceptors,
  clearUserData,
  errorResponseHandler,
};
